// extracted by mini-css-extract-plugin
export default {"brandCard":"Brands_brandCard__ZDHX0","categoryImage":"Brands_categoryImage__OFazR","brandName":"Brands_brandName__oqpz6","overlay":"Brands_overlay__I4K2v"};